var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"videolist-vertical"},_vm._l((_vm.displayedPosts12),function(post,index){return _c('VideoListVerticalItem',{key:index,staticClass:"video-item-content",attrs:{"post":post}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }